module.exports = __webpack_public_path__ + "fonts/Nunito-Bold.c0844c99.ttf";